import React, { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Desktop collapse state lives here (persisted) so it survives page
  // navigation — each page mounts its own <Sidebar/>, which would otherwise
  // reset a local useState back to expanded.
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem('tp-sidebar-collapsed') === '1';
    } catch {
      return false;
    }
  });

  const toggleCollapsed = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('tp-sidebar-collapsed', next ? '1' : '0');
      } catch {
        // storage unavailable (private mode) — state still works for this session
      }
      return next;
    });
  };

  const closeMobileMenu = () => {
    console.log('🚫 Closing mobile sidebar (modal opened)');
    setIsMobileMenuOpen(false);
  };
  
  const openMobileMenu = () => {
    console.log('📱 Opening mobile sidebar');
    setIsMobileMenuOpen(true);
  };
  
  const toggleMobileMenu = () => {
    console.log('🔄 Toggling mobile sidebar');
    setIsMobileMenuOpen(prev => !prev);
  };

  return (
    <SidebarContext.Provider value={{
      isMobileMenuOpen,
      closeMobileMenu,
      openMobileMenu,
      toggleMobileMenu,
      isCollapsed,
      toggleCollapsed,
      setIsMobileMenuOpen // Keep for backward compatibility
    }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};